<ng-template #checkboxContents>
  @if (control) {
    <input
      type="checkbox"
      class="checkbox__control"
      [formControl]="control"
      [attr.disabled]="disabled ? disabled : null"
      [name]="name"
      [value]="value"
      >
  }

  @if (!control) {
    <input
      type="checkbox"
      class="checkbox__control"
      [attr.disabled]="disabled ? disabled : null"
      [name]="name"
      [value]="value"
      >
  }

  <span class="checkbox__ui"></span>

  <span class="checkbox__label"><ng-content></ng-content></span>
</ng-template>

@if (!readonly) {
  <label class="checkbox" [ngClass]="[(size) ? size + '--' : '']" [class.full-width--]="fullWidth">
    <ng-container *ngTemplateOutlet="checkboxContents"></ng-container>
  </label>
}

@if (readonly) {
  <span class="checkbox" [ngClass]="(size) ? size + '--' : ''" [class.full-width--]="fullWidth">
    <ng-container *ngTemplateOutlet="checkboxContents"></ng-container>
  </span>
}
